import React, { FunctionComponent, useEffect } from 'react';
import CourseAccess from './Access/CourseAccess';
import Delivery from './Delivery/Delivery';
import ProvisionCoursesStepper from './ProvisionCoursesStepper';
import ApplyRules from './Apply/ApplyRules';
import { useCourseState, ProvisionCourseStep } from '../../context/CourseContext';
import BaseSheet from '../Common/Layout/BaseSheet';
import { Product } from '@beable/roster-backend-client-v1';

export default function ProvisionCoursesSheet() {
  const { activeStep, product, site } = useCourseState();

    useEffect(() => {
      const container = document.getElementById('provision-courses-container');
      if (container) container.scrollTo(0, 0);
    }, [activeStep, site])

    let StepComponent: FunctionComponent;

    switch (activeStep) {
      case ProvisionCourseStep.Access:
        StepComponent = CourseAccess;
        break;
      case ProvisionCourseStep.Delivery:
        StepComponent = Delivery;
        break;
      case ProvisionCourseStep.Provision:
        StepComponent = ApplyRules;
        break;
      default:
        StepComponent = CourseAccess;
    }

  return (
    <BaseSheet id='provision-courses-container'>
      { product?.code === Product.Literacy &&
        <ProvisionCoursesStepper />
      }
      <StepComponent />
    </BaseSheet>
  );
}
